import { ValidationStopReason } from "../../../system/Domain";

function formatValidationStopReason(reason: ValidationStopReason) {
	switch (reason) {
		case "Other":
			return "Andere";
		case "Recalculation":
			return "Rekalkulation";
		case "ContractChange":
			return "Umstufung";
		case "Assessment":
			return "Gutachten";
		case "Admission":
			return "Zulassung";
		case "Stray":
			return "Irrläufer";
		default:
			return reason;
	}
}

export default formatValidationStopReason;
